import { render, staticRenderFns } from "./ColumnMappingPreview.vue?vue&type=template&id=9d8cabaa&scoped=true&"
import script from "./ColumnMappingPreview.vue?vue&type=script&lang=js&"
export * from "./ColumnMappingPreview.vue?vue&type=script&lang=js&"
import style0 from "./ColumnMappingPreview.vue?vue&type=style&index=0&id=9d8cabaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8cabaa",
  null
  
)

export default component.exports